module.exports = __webpack_public_path__ + "static/media/gh.031ea242.svg";